import { RIGHT_SIDEBAR_OVERLAY_PANEL_WIDTH_PX } from "../Components/Common/rightSidebarOverlayPanelWidth.js";
import { TEAM_PEOPLE_PANEL_MAX_WIDTH_PX } from "../Helpers/teamPeoplePanelResize.js";

export const ACTIVITY_PANEL_PINNED = {
    PINNED: "pinned",
    UNPINNED: "unpinned",
};

/** Default pinned activity drawer width (matches Quick Actions overlay). */
export const ACTIVITY_DRAWER_WIDTH_PX = 401;

/** Minimum resizable pinned activity drawer width (Workline Filter overlay). */
export const ACTIVITY_DRAWER_MIN_WIDTH_PX =
    RIGHT_SIDEBAR_OVERLAY_PANEL_WIDTH_PX;

/** Maximum resizable pinned activity drawer width (matches Team people panel). */
export const ACTIVITY_DRAWER_MAX_WIDTH_PX = TEAM_PEOPLE_PANEL_MAX_WIDTH_PX;

/** Prepend avatar size in Conversation History and collapsed activity list rows. */
export const CONVERSATION_HISTORY_LIST_AVATAR_SIZE_PX = 25;

/** Activity list prepend avatar when collapsed to one line per row. */
export const ACTIVITY_LIST_COLLAPSED_PREPEND_AVATAR_SIZE_PX =
    CONVERSATION_HISTORY_LIST_AVATAR_SIZE_PX;

/** Activity list prepend avatar when expanded (multi-line rows). */
export const ACTIVITY_LIST_EXPANDED_PREPEND_AVATAR_SIZE_PX = 50;

/** Inline gap between sender avatar, label, event icon, and preview text (matches Vuetify `mr-2`). */
export const ACTIVITY_LIST_LAST_MESSAGE_INLINE_GAP_PX = 8;

/**
 * @param {boolean} activityExpandedList Collapsed one-line list when true.
 * @returns {number}
 */
export function getActivityListPrependAvatarSizePx(activityExpandedList) {
    return activityExpandedList
        ? ACTIVITY_LIST_COLLAPSED_PREPEND_AVATAR_SIZE_PX
        : ACTIVITY_LIST_EXPANDED_PREPEND_AVATAR_SIZE_PX;
}

/** Default visible avatars on the work-panel chin (matches k-work-panel-chin). */
export const ACTIVITY_PANEL_CHIN_MAX_VISIBLE_AVATARS = 12;

/** Narrower pinned activity drawer strip — fewer avatars before +N. */
export const ACTIVITY_DRAWER_CHIN_MAX_VISIBLE_AVATARS = 7;

/**
 * @param {"panel" | "drawer"} layoutMode
 * @returns {number}
 */
export function getActivityChinMaxVisibleAvatars(layoutMode) {
    return layoutMode === "drawer"
        ? ACTIVITY_DRAWER_CHIN_MAX_VISIBLE_AVATARS
        : ACTIVITY_PANEL_CHIN_MAX_VISIBLE_AVATARS;
}

/**
 * @param {"panel" | "drawer"} layoutMode
 * @returns {boolean}
 */
export function shouldShowActivityChinTitle(layoutMode) {
    return layoutMode !== "drawer";
}

/**
 * Pinned activity drawer rows show the last-message sender avatar only (no name label).
 *
 * @param {"panel" | "drawer"} layoutMode
 * @returns {boolean}
 */
export function shouldShowActivityListSenderName(layoutMode) {
    return layoutMode !== "drawer";
}
